import { SliderModal } from '@see-ui/core';
import NavLink from '@components/NavLink/NavLink';

interface MobileMenuProps {
  showMobileSlider: boolean;
  onClose: (showMobileSlider: boolean) => void;
}
function MobileMenu({ showMobileSlider, onClose }: MobileMenuProps) {
  const handleSliderClose = (e) => {
    onClose(false);
  };

  return (
    <div>
      <>
        <SliderModal
          direction="right"
          labelAriaCloseBtn="Close Modal"
          onClose={handleSliderClose}
          open={showMobileSlider}
        >
          <SliderModal.Body>
            <NavLink />
          </SliderModal.Body>
        </SliderModal>
      </>
    </div>
  );
}
export default MobileMenu;
